import { codes } from '@/constant';
export * from '@/utils/time';

export const delayApi = sleep =>
  Promise.all([
    new Promise(resolve => setTimeout(resolve, 1000)),
    new Promise(resolve => setTimeout(resolve, sleep)),
  ]);

export const findCountry = number =>
  Object.keys(codes).find(code => number.includes(codes[code]));

export const stripExtensionCode = number => number.replace(/\+65|\+66/g, '');
export const addExtensionCode = (country, number) =>
  `${codes[country]}${number}`;

export const dateURItoFile = dataURI => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const dw = new DataView(ab);

  for (let i = 0; i < byteString.length; i++) {
    dw.setUint8(i, byteString.charCodeAt(i));
  }

  const blob = new Blob([ab], { type: mimeString });
  const extension = mimeString.split('/').pop();

  const file = new File([blob], `${Date.now().toString()}.${extension}`, {
    lastModified: Date.now(),
    type: mimeString,
  });

  return file;
};
